'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parser = require('./parser');

var _parser2 = _interopRequireDefault(_parser);

var _regex = require('./regex');

var _regex2 = _interopRequireDefault(_regex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Factory function to return parser instance
var Urls = function Urls() {
  var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return new _parser2.default(text);
};

// Expose regex here for easy access
Urls.regex = _regex2.default;

exports.default = Urls;
module.exports = exports['default'];